import { Link } from "react-router-dom";
import ScrollReveal from "@/components/base/ScrollReveal";

export default function PhilosophyPreview() {
  return (
    <section className="relative w-full overflow-hidden bg-foreground-950 py-24 md:py-32">
      <div className="absolute inset-0 h-full w-full">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20dark%20textured%20background%20of%20black%20marble%20with%20delicate%20thin%20golden%20veins%2C%20sophisticated%20minimal%20luxury%20aesthetic%2C%20soft%20directional%20lighting%2C%20mostly%20deep%20dark%20tones%2C%20elegant%20calm%20editorial%20photography%2C%20high%20detail&width=1600&height=1000&seq=revra-philosophy-bg&orientation=landscape"
          alt="経営理念イメージ"
          className="h-full w-full object-cover opacity-30"
        />
      </div>
      <div className="absolute inset-0 bg-foreground-950/70" />

      <div className="relative z-10 mx-auto w-full max-w-7xl px-6 md:px-12 lg:px-20">
        <ScrollReveal>
          <div className="flex flex-col items-center text-center">
            <span className="font-label text-xs tracking-[0.4em] text-accent-300">PHILOSOPHY</span>
            <h2 className="mt-6 font-display text-3xl font-light leading-[1.7] tracking-[0.06em] text-background-50 md:text-5xl">
              ヒトが価値を創り、
              <br className="md:hidden" />
              ヒトが未来を変える
            </h2>
            <p className="mt-8 max-w-2xl font-body text-sm leading-[2.2] text-background-300">
              私たちは、ヒトの可能性を信じる。挑戦を通じて一人ひとりの可能性を価値へと変え、
              その価値で未来を変えていく。
            </p>
          </div>
        </ScrollReveal>

        <div className="mt-16 grid grid-cols-1 gap-px bg-background-50/10 md:grid-cols-2">
          <ScrollReveal>
            <div className="flex h-full flex-col bg-foreground-950/60 p-8 md:p-12">
              <span className="font-label text-[11px] tracking-[0.32em] text-accent-400">
                MISSION
              </span>
              <h3 className="mt-5 font-heading text-xl leading-[1.9] text-background-50">
                ヒトの可能性を、価値に変える
              </h3>
              <p className="mt-5 font-body text-sm leading-[2] text-background-400">
                一人ひとりの個性や才能を引き出し、社会に必要とされる価値へと変えていく。
              </p>
            </div>
          </ScrollReveal>
          <ScrollReveal delay={120}>
            <div className="flex h-full flex-col bg-foreground-950/60 p-8 md:p-12">
              <span className="font-label text-[11px] tracking-[0.32em] text-accent-400">VISION</span>
              <h3 className="mt-5 font-heading text-xl leading-[1.9] text-background-50">
                挑戦するヒトが、次の時代をつくる会社へ
              </h3>
              <p className="mt-5 font-body text-sm leading-[2] text-background-400">
                挑戦する仲間が集まり、共に成長し、新たな価値を生み出し続ける会社を目指す。
              </p>
            </div>
          </ScrollReveal>
        </div>

        <ScrollReveal delay={200}>
          <div className="mt-14 flex justify-center">
            <Link
              to="/company/philosophy"
              className="inline-flex items-center gap-3 whitespace-nowrap border border-background-100/40 px-9 py-3.5 font-body text-[12px] tracking-[0.22em] text-background-50 transition-colors hover:bg-background-50 hover:text-foreground-950"
            >
              VIEW PHILOSOPHY
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}